import { TrashIcon, CogIcon, QrcodeIcon, LockClosedIcon } from '@heroicons/react/solid'
import { useState } from 'react'
import { Dropdown, DropdownDivider, DropdownItem } from 'ui/components/Dropdown'
import { CheckInButton } from '../ClientDetail'
import { DeleteConfirmation } from '../DeleteConfirmation'
import { ManageBarcodeModal } from '../ManageBarcodeModal'
import { LockConfirmation } from '../LockConfirmation'
import { CUSTOMERS_MANAGE, CUSTOMERS_UNLOCK } from 'constants/permissions'
import { useCurrentUserCanForCurrentBrand } from 'hooks/UseCurrentUserCan'
import { useTranslation } from 'react-i18next'

export const ClientHeader = ({ isLoading, client }) => {
  const { t } = useTranslation()
  const can = useCurrentUserCanForCurrentBrand()
  const userCanManageClients = can(CUSTOMERS_MANAGE)
  const userCanUnlockClients = can(CUSTOMERS_UNLOCK)
  const [showingDeleteConfirmation, setShowingDeleteConfirmation] = useState(null)
  const [showingManageBarcode, setShowingManageBarcode] = useState(null)
  const [showingLockConfirmation, setShowingLockConfirmation] = useState([null, null])

  return (
    <div>
      {!isLoading && client.deleted_at === null && (
        <div className="flex items-center space-x-2">
          <CheckInButton client={client} />

          <Dropdown buttonLabel="Settings" buttonLeadingIcon={CogIcon}>
            <DropdownItem
              icon={QrcodeIcon}
              label="Manage passes"
              onClick={() => setShowingManageBarcode(client.id)}
            />
            <DropdownItem
              icon={LockClosedIcon}
              label={client.locked_at ? 'Unlock' : 'Lock'}
              disabled={client.locked_at ? !userCanUnlockClients : !userCanManageClients}
              disabledReason={
                client.locked_at
                  ? t('tooltip.missing_permission.clients_unlock')
                  : t('tooltip.missing_permission.clients_manage')
              }
              onClick={() =>
                setShowingLockConfirmation([client.id, client.locked_at ? 'unlocking' : 'locking'])
              }
            />
            <DropdownDivider />
            <DropdownItem
              icon={TrashIcon}
              label="Delete"
              disabled={client.locked_at || !userCanManageClients}
              disabledReason={
                !userCanManageClients ? t('tooltip.missing_permission.clients_manage') : undefined
              }
              onClick={() => setShowingDeleteConfirmation(client.id)}
            />
          </Dropdown>
        </div>
      )}

      <ManageBarcodeModal
        isOpen={showingManageBarcode !== null}
        onClose={() => setShowingManageBarcode(null)}
      />

      <DeleteConfirmation
        clientId={showingDeleteConfirmation}
        onClose={() => setShowingDeleteConfirmation(null)}
      />

      <LockConfirmation
        clientId={showingLockConfirmation[0]}
        onClose={() => setShowingLockConfirmation([null, null])}
        state={showingLockConfirmation[1]}
      />
    </div>
  )
}
